export default {
    computed: {
        loginUrl() {
            if (!this.$page.props.auth.user) {
                return this.$route('oauthLogin')
            }

            const surveyToken = this.$page.props.auth.user.email
            const chapterId = this.$route().params.chapitre ?? null
            const sectionId = this.$route().params.section ?? null
            const step = this.$route().params.etape ?? null

            return this.$route('oauthLogin', {
                token: surveyToken,
                chapter_id: chapterId,
                section_id: sectionId,
                step: step,
            })
        },
        registerUrl() {
            const user = this.$page.props.auth.user
            const surveyToken = user ? user.email : null
            const chapterId = this.$route().params.chapitre ?? null
            const sectionId = this.$route().params.section ?? null

            const redirectUrl = this.$route('oauthLogin', {
                token: surveyToken,
                chapter_id: chapterId,
                section_id: sectionId,
            })
            return (
                this.$page.props.apiRootUrl +
                '/register?redirect_url=' +
                redirectUrl
            )
        },
    },
}
